// src/api/client.ts

import axios, { AxiosError, AxiosResponse } from "axios";

export const BASE_URL =
  (window as any).__ENV__?.REACT_APP_API_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:8080";

// Timeout normal para peticiones de API: 15s
// Para uploads de video/archivos grandes se sobreescribe por llamada (ver auctionLotApi.ts)
const client = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

/**
 * Timeout extendido para uploads de archivos grandes (videos de lotes).
 * Un video de 100 MB con conexión de 10 Mbps tarda ~80 segundos solo en
 * la transferencia al servidor, más el tiempo de subida a S3.
 * Se usa 5 minutos (300 000 ms) como margen seguro.
 */
export const UPLOAD_TIMEOUT_MS = 300_000; // 5 minutos

// ── Request interceptor: attach JWT ──────────────────────────────────────────
client.interceptors.request.use((config) => {
  // Primero busca el token del panel admin, luego el legacy
  const token =
    localStorage.getItem("fg_admin_token") || localStorage.getItem("fg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ── Response interceptor: handle 401 ─────────────────────────────────────────
// IMPORTANTE: /subasta-obs es una ruta pública usada por OBS Studio.
// Desde OBS nunca habrá token de admin. Si el interceptor redirige a /login
// cuando alguna llamada devuelve 401, OBS mostrará el LoginPage en lugar
// de la página de subasta → BUG visual crítico.
// Solución: ignorar el 401 si la ruta actual es una ruta pública OBS.
const PUBLIC_OBS_PATHS = ["/subasta-obs"];

client.interceptors.response.use(
  (res: AxiosResponse) => res,
  (error: AxiosError<any>) => {
    if (error.response?.status === 401) {
      // No redirigir si estamos en una ruta pública (OBS, etc.)
      const currentPath = window.location.pathname;
      const esRutaPublica = PUBLIC_OBS_PATHS.some((p) =>
        currentPath.startsWith(p),
      );
      if (!esRutaPublica) {
        localStorage.removeItem("fg_admin_token");
        localStorage.removeItem("fg_admin_user");
        localStorage.removeItem("fg_token");
        localStorage.removeItem("fg_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default client;
